import Actions from 'actions'
import { relationship } from 'consts'
import { STEPS } from 'consts/flowConsts'
import dayjs from 'dayjs'
import { getMemberEffectiveDate } from 'utils/memberUtils'
import { v4 as uuidv4 } from 'uuid'

export const defaultDebugApplication = {
  applicationId:
    '10c9fe003122915aec968c8bc769dbc307ce67d86ec7e1f4d41033fe2e0f06b2'
}
export const defaultZipayload = {
  data: {
    zipCode: '43001',
    countyList: [
      {
        value: 'Licking County',
        label: 'Licking County'
      }
    ],
    selectedCounty: null
  },
  status: 'ok'
}

export const defaultDebugEnrollee = {
  firstName: 'John',
  lastName: 'Doe',
  ssn: '123-45-6789',
  dob: '2000-02-02',
  sex: 'male',
  isTobbacoUser: false,
  isElligible: false,
  phone: '+12345678902',
  email: 'john.doe@example.com',
  relation: relationship.owner,
  homeAddress: {
    state: 'OH',
    zipCode: '43001',
    county: 'Licking',
    city: 'Newark',
    address1: '123 Main St',
    address2: 'Apt 4B'
  },
  isMailingAddressAsHomeAddress: true,
  mailingAddress: null,
  prefferedLanguage: 'english'
}

export const defaultQulifyLifeEventPayload = {
  reason: 'Lost minimum essential healthcare coverage',
  coverageStartDate: getMemberEffectiveDate(),
  date: dayjs().format('YYYY-MM-DD')
}
/* eslint import/no-anonymous-default-export: [2, {"allowObject": true}] */
export default {
  defaultDebugApplication,
  defaultZipayload,
  defaultDebugEnrollee,
  defaultQulifyLifeEventPayload
}

export const getSkipStepAction = currentStep => {
  switch (currentStep) {
    case STEPS.INFO: {
      return {
        action: Actions.AUTO_FILL_ENROLLEES,
        payload: defaultDebugEnrollee
      }
    }
    case STEPS.QUALIFICATION: {
      return {
        action: Actions.AUTO_FILL_QUALLIFY_LIFE_EVENT,
        payload: defaultQulifyLifeEventPayload
      }
    }
    case STEPS.DETAILS: {
      return {
        action: Actions.AUTO_FILL_ENROLLEES,
        payload: defaultDebugEnrollee
      }
    }
    default:
      return { action: null, payload: null }
  }
}
